let parentOrigin: string | undefined

export function publishEmbeddedCanvas() {
  if (!parentOrigin || typeof window === 'undefined' || typeof document === 'undefined') return
  const color = getComputedStyle(document.documentElement).backgroundColor
  const match = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/.exec(color)
  if (!match) return
  const channels = match.slice(1).map(Number)
  if (channels.some(value => value > 255)) return
  const background = '#' + channels.map(value => value.toString(16).padStart(2, '0')).join('')
  window.parent.postMessage({ type: 'c2p:embed-canvas', background }, parentOrigin)
}

export function initEmbeddedCanvas() {
  if (typeof window === 'undefined' || typeof document === 'undefined' || !window.parent || window.parent === window) return () => undefined
  const root = document.documentElement
  const finishColorTransition = (event: TransitionEvent) => {
    if (event.target === root && event.propertyName === 'background-color') publishEmbeddedCanvas()
  }
  const receive = (event: MessageEvent) => {
    if (event.source !== window.parent || event.data?.type !== 'c2p:embed-canvas-request') return
    try {
      const origin = new URL(event.origin)
      if (!['http:', 'https:'].includes(origin.protocol) || origin.origin !== event.origin) return
    } catch { return }
    parentOrigin = event.origin
    publishEmbeddedCanvas()
  }
  window.addEventListener('message', receive)
  root.addEventListener('transitionend', finishColorTransition)
  return () => {
    parentOrigin = undefined
    window.removeEventListener('message', receive)
    root.removeEventListener('transitionend', finishColorTransition)
  }
}

const dispose = initEmbeddedCanvas()
if (import.meta.hot) import.meta.hot.dispose(dispose)
